import * as Sentry from '@sentry/react'

interface InitSentryOptions {
  dsn: string
  environment?: string
  release?: string
}

export function initSentry({ dsn, environment = 'development', release }: InitSentryOptions) {
  Sentry.init({
    dsn,
    environment,
    enabled: environment !== 'development',
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: environment === 'prod' ? 0.1 : 1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      /Loading chunk .* failed/,
      /Failed to fetch dynamically imported module/,
    ],
    denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i],
  })
}

export function addSentryBreadcrumb(category: string, message: string) {
  Sentry.addBreadcrumb({ category, message })
}

export function setSentryTag(key: string, value: string) {
  Sentry.setTag(key, value)
}
